import EventTimeZoneService from 'src/modules/eventTimeZone/eventTimeZoneService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'EVENTTIMEZONE_FORM';

const eventTimeZoneFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: eventTimeZoneFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await EventTimeZoneService.find(id);
      }

      dispatch({
        type: eventTimeZoneFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventTimeZoneFormActions.INIT_ERROR,
      });

      getHistory().push('/event-time-zone');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: eventTimeZoneFormActions.CREATE_STARTED,
      });

      await EventTimeZoneService.create(values);

      dispatch({
        type: eventTimeZoneFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.eventTimeZone.create.success'),
      );

      getHistory().push('/event-time-zone');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventTimeZoneFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: eventTimeZoneFormActions.UPDATE_STARTED,
      });

      await EventTimeZoneService.update(id, values);

      dispatch({
        type: eventTimeZoneFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.eventTimeZone.update.success'),
      );

      getHistory().push('/event-time-zone');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventTimeZoneFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default eventTimeZoneFormActions;
